<script setup>
const { $notify } = useNuxtApp()
const { t } = useI18n()
const loading = ref(false)
const valid = ref(false)

const { loggedIn, user, fetch: refreshSession } = useUserSession()
const credentials = reactive({
  username: '',
  password: ''
})

async function login() {
  loading.value = true
  $fetch('/api/auth/login', {
    method: 'POST',
    body: credentials
  })
    .then(async () => {
      $notify('login.ok', 'success')
      console.error(loggedIn.value, user.value)
      // Refresh the session on client-side and redirect to the home page
      await refreshSession()
      await navigateTo('/admin')
    })
    .catch(() => {
      $notify('Login error', 'error')
    })
  loading.value = false
}

function required(v) { return !!v || t('Field is required') }
</script>

<template>
<v-card
  width="350"
  class="mt-5 mx-auto"
>
  <v-card-title>{{ $t('login.signin') }}</v-card-title>
  <v-card-subtitle>{{ $t('login.signin_description') }}</v-card-subtitle>
  <v-card-text>
    <v-form
      v-model="valid"
      @submit.prevent="login"
    >
      <v-text-field
        v-model="credentials.username"
        :readonly="loading"
        :rules="[required]"
        class="my-4"
        clearable
        label="Email"
      />

      <v-text-field
        v-model="credentials.password"
        :readonly="loading"
        :rules="[required]"
        clearable
        class="my-4"
        type="password"
        :label="$t('login.password')"
        :placeholder="$t('login.password_placeholder')"
      />

      <v-btn
        :disabled="!valid || loading"
        :loading="loading"
        block
        color="primary"
        size="large"
        type="submit"
      >
        {{ $t('login.signin') }}
      </v-btn>
    </v-form>
  </v-card-text>
</v-card>
</template>
